(ns practitest.frontend.xbot.agents-view.av-agent-details
  (:require
    [clojure.string :as string]
    [re-frame.core :as re-frame]
    [practitest.frontend.xbot.events :as events]
    [practitest.frontend.xbot.agents-view.av-common :as av-common]
    [practitest.frontend.components.icons :as icons]))

(defn agent-details-row [title data]
  [:p
   title
   [:span.bold
    data]])

(defn client-id-input [client-id state]
  [:label
   [:input
    {:type          :text
     :default-value client-id
     :onChange      (fn [e]
                      (.preventDefault e)
                      (swap! state assoc :tmp-client-id (.. e -target -value)))}]])

(defn client-id-icon [id client-id state]
  (let [tmp-client-id (or (:tmp-client-id @state) client-id)]
    [:span {:style {:cursor "pointer"}
            :on-click (fn [_]
                        (when (:edit-client-id? @state)
                          (re-frame/dispatch
                            [::events/set-agent-client-id {:agent-id id :client-id tmp-client-id}]))
                        (swap! state update :edit-client-id? not))}
     (if (:edit-client-id? @state)
       [icons/save-fill]
       [icons/pencil-fill])]))

(defn agent-details-client-id [{:keys [busy? client-id]} id state]
  [:p
   "Client Type: "
   [:span.bold
    (if (and (not busy?) (:edit-client-id? @state))
      [client-id-input client-id state]
      (str client-id " "))]
   (when-not busy?
     [client-id-icon id client-id state])])

(defn display-agent-details [{:keys [online? uptime] :as agent} id state]
  [:div.top-text.col-sm-12.col-md-12.col-lg-12.agent-details
   [av-common/agent-view-titles "Agent Details: "]
   [agent-details-client-id agent id state]
   [agent-details-row "Process ID: " (last (string/split (:id agent) #":"))]
   [agent-details-row "Operating System: " (get-in agent [:machine :os])]
   (when (and online? uptime)
     [agent-details-row
      "Online since: "
      (.format (.subtract (js/moment) (* uptime 1000)) "YYYY-MM-DD, HH:mm")])])
